import React from 'react';
import glamorous, { withTheme } from 'glamorous';
import Spinner from 'react-spinkit';

import Logo from '../../assets/Logo';
import { mixins } from '../../styles';

const Container = withTheme(glamorous.div({
  zIndex: 10,
  position: 'fixed',
  ...mixins.fillToParent,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 16,
}, ({ theme, fadingOut, fadingOutDuration }) => ({
  background:
    `radial-gradient(ellipse at center, ${theme.primary.base} 0%, ${theme.primary.darker} 100%)`,

  opacity: fadingOut ? 0 : 1,
  transitionProperty: 'opacity',
  transitionTiming: 'ease-in-out',
  transitionDuration:  `${fadingOutDuration}ms`,
})));

const styleLogo = {
  width: 350,
  maxWidth: '100%',
  height: 'auto',
  marginBottom: 64,
};

class Loader extends React.PureComponent {
  render() {
    return (
      <Container
        fadingOut={this.props.fadingOut}
        fadingOutDuration={this.props.fadingOutDuration}
      >
        <Logo
          white
          style={styleLogo}
        />

        <Spinner
          fadeIn="quarter"
          name="ball-beat"
          color="#ffffff"
        />
      </Container>
    );
  }
}

export default withTheme(Loader);



// WEBPACK FOOTER //
// ./src/components/ui/Loader.js